import * as React from 'react';
import { Button, Form, Input } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { NmvsProviderCredentials } from 'types/tenants/nmvs-provider-credentials';

import 'pages/settings/styles.css';

export interface Props {
  isProcessing: boolean;
  isOnline: boolean;
  canUpdate: boolean;
  updateNmvsProviderCredentials: (nmvsProviderCredentials: NmvsProviderCredentials) => void;
}

interface State {
  clientLoginId: string;
  nmvsUsername: string;
  nmvsPassword: string;
  certificatePassword: string;
}

export class ArvatoForm extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.setClientLoginId = this.setClientLoginId.bind(this);
    this.setNmvsUsername = this.setNmvsUsername.bind(this);
    this.setNmvsPassword = this.setNmvsPassword.bind(this);
    this.setCertificatePassword = this.setCertificatePassword.bind(this);
    this.updateNmvsProviderCredentials = this.updateNmvsProviderCredentials.bind(this);
    this.invalidForm = this.invalidForm.bind(this);
    this.isInvalid = this.isInvalid.bind(this);

    this.state = {
      clientLoginId: '',
      nmvsUsername: '',
      nmvsPassword: '',
      certificatePassword: ''
    } as State;
  }

  public render() {
    const i18n = getI18n();

    return (
        <Form>
          <Form.Field className="username-field">
            <label className="settings-label">{i18n.t(translations.Username)}</label>
            <Form.Group>
              <Form.Input width={4}
                className="settings-input client-login-id"
                name="arvato-client-login-id"
                value={this.state.clientLoginId}
                onChange={this.setClientLoginId}/>
              <span className="settings-username-seperator">/</span>
              <Form.Input width={12}
                className="settings-input nmvs-username"
                name="arvato-username"
                value={this.state.nmvsUsername}
                onChange={this.setNmvsUsername} />
            </Form.Group>
          </Form.Field>
          <Form.Field className="password-field">
            <label className="settings-label">{i18n.t(translations.Password)}</label>
            <Input className="settings-input"
              type="password"
              name="arvato-password"
              value={this.state.nmvsPassword}
              onChange={this.setNmvsPassword} />
          </Form.Field>
          <Form.Field className="certificate-password-field">
            <label className="settings-label">{i18n.t(translations.CertificatePassword)}</label>
            <Input className="settings-input"
              type="password"
              name="arvato-certificate-password"
              value={this.state.certificatePassword}
              onChange={this.setCertificatePassword} />
          </Form.Field>
          {
            this.props.canUpdate ?
              <Button type="submit"
                className="save-button neutral button align-right"
                disabled={this.invalidForm() || this.props.isProcessing || !this.props.isOnline}
                loading={this.props.isProcessing}
                onClick={this.updateNmvsProviderCredentials}>
                {i18n.t(translations.Save)}
              </Button>
              : null
          }
        </Form>
    );
  }

  private setClientLoginId(event: React.FormEvent<HTMLInputElement>): void {
    this.setState({
      clientLoginId: event.currentTarget.value
    });
  }

  private setNmvsUsername(event: React.FormEvent<HTMLInputElement>): void {
    this.setState({
      nmvsUsername: event.currentTarget.value
    });
  }

  private setNmvsPassword(event: React.FormEvent<HTMLInputElement>): void {
    this.setState({
      nmvsPassword: event.currentTarget.value
    });
  }

  private setCertificatePassword(event: React.FormEvent<HTMLInputElement>): void {
    this.setState({
      certificatePassword: event.currentTarget.value
    });
  }

  private updateNmvsProviderCredentials() {
    this.props.updateNmvsProviderCredentials({
      clientLoginId: this.state.clientLoginId,
      nmvsUsername: this.state.nmvsUsername,
      nmvsPassword: this.state.nmvsPassword,
      certificatePassword: this.state.certificatePassword
    } as NmvsProviderCredentials);
  }

  private invalidForm = (): boolean => {
    const invalid = (
      this.isInvalid(this.state.clientLoginId) ||
      this.isInvalid(this.state.nmvsUsername) ||
      this.isInvalid(this.state.nmvsPassword) ||
      this.isInvalid(this.state.certificatePassword)
    );
    return invalid;
  }

  private isInvalid(text: string): boolean {
    return text === undefined ||
      text === null ||
      text === '';
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/arvato-form.tsx